import { render, staticRenderFns } from "./warnList.vue?vue&type=template&id=7123a02f&scoped=true&"
import script from "./warnList.vue?vue&type=script&lang=js&"
export * from "./warnList.vue?vue&type=script&lang=js&"
import style0 from "./warnList.vue?vue&type=style&index=0&id=7123a02f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7123a02f",
  null
  
)

export default component.exports